import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 20,
	viewBox: "0 0 15 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.3078205,0.681673065 L14.1105345,5.74662453 C14.5266122,6.10980179 14.5694966,6.74151282 14.2063193,7.1575906 C13.8710788,7.5416624 13.3070284,7.60774689 12.8949786,7.32999237 L12.7953533,7.25337547 L9.297,4.19967307 L9.29747574,16.6246613 C9.2998595,18.4349117 8.29101739,19.5420407 6.55993899,19.6188123 L6.36463947,19.6230857 L1,19.6230857 C0.44771525,19.6230857 0,19.1753705 0,18.6230857 C0,18.1102499 0.38604019,17.6875786 0.883378875,17.6298135 L1,17.6230857 L6.36463947,17.6230857 C7.04935333,17.6230857 7.27101287,17.438273 7.29519112,16.7668439 L7.29747238,16.6259804 L7.297,4.15367307 L3.62131248,7.26360543 C3.23202544,7.59277555 2.66445756,7.57311073 2.29896659,7.23643742 L2.21202389,7.14568316 C1.88285377,6.75639611 1.90251859,6.18882824 2.23919191,5.82333726 L2.32994616,5.73639457 L8.3078205,0.681673065 Z"
	})
});
export default SvgUpArrow;
